/* eslint-disable */

export interface UiAlias {
  type?: UiAliasType;
  /**
   * The canonical text of the alias. For SMS numbers, it is the 10 digits. For email addresses,
   * it is the lowercase representation.
   */
  canonical_text?: string;
  /** If the alias has a preferred formatted value, return this as well. Example are phone numbers. */
  formatted?: string;
}

export enum UiAliasType {
  SMS = "SMS",
  EMAIL = "EMAIL",
  APP = "APP",
}
